/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_TitleInputs */

const cs_settings_calendar_title = /** @type {(inputs: Settings_Calendar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalendáře`)
};

const en_settings_calendar_title = /** @type {(inputs: Settings_Calendar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendars`)
};

/**
* | output |
* | --- |
* | "Calendars" |
*
* @param {Settings_Calendar_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_title = /** @type {((inputs?: Settings_Calendar_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_title(inputs)
	return cs_settings_calendar_title(inputs)
});